/**
 * Shared constants + tiny helpers for the Math Engine workflow.
 *
 * Kept in one file because each one is too small to deserve its own
 * module, but they don't belong in any single stage component either.
 */

// Grades we have SCDSB scope/sequence coverage for. Split-grade pairs are
// interleaved between their component grades — one tap in the same Step 1
// grid, canonical label "Grade N/M" (the only format used in the button,
// the request param, and the crosswalk lookup). Only adjacent pairs exist.
export const SUPPORTED_GRADES = [
  "Grade 4",
  "Grade 4/5",
  "Grade 5",
  "Grade 5/6",
  "Grade 6",
  "Grade 6/7",
  "Grade 7",
  "Grade 7/8",
  "Grade 8",
];

// Diagnostic answer letters. Used by both the diagnostic results form
// (columns) and the per-question correct-answer highlighting.
export const LETTERS = ["A", "B", "C", "D"];

/**
 * Format an ISO timestamp as a fuzzy "N min ago" / "N h ago" / "N d ago"
 * string for the resume panel cards. Defensive against bad ISO strings.
 */
export const formatRelTime = (iso) => {
  try {
    const d = new Date(iso);
    const diffMin = Math.round((Date.now() - d.getTime()) / 60000);
    if (diffMin < 60) return `${Math.max(1, diffMin)} min ago`;
    if (diffMin < 60 * 24) return `${Math.round(diffMin / 60)} h ago`;
    return `${Math.round(diffMin / (60 * 24))} d ago`;
  } catch {
    return "";
  }
};
